import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventAgendaGroup extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventAgendaGroup';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventGuestId: null,
            fAgendaId: null
        }
    }
}

const servicePath = 'f-agenda-groups';
const servicePlugin = makeServicePlugin({
    Model: EventAgendaGroup,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin